import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M28.21,15.68,22,26.41H10L4,16,10,5.59h10.4V4.29H9.61a.65.65,0,0,0-.56.32L2.67,15.68a.63.63,0,0,0,0,.65L9.05,27.39a.65.65,0,0,0,.56.32H22.39a.65.65,0,0,0,.56-.32l6.38-11.06Z' }),
  React.createElement('path', { d: 'M15.54,15.58l.69,1.11,9.54-6-.69,2.82,1.26.32.9-3.66a1.39,1.39,0,0,0-1-1.68l-3.65-.9-.31,1.26,2.87.71Z' })
));